import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  BiHome,
  BiCategory,
  BiHeart,
  BiLogInCircle,
  BiCart,
} from "react-icons/bi";
import { MdAccountBox, MdLocalOffer } from "react-icons/md";
import { useSelector } from "react-redux";

const DownBar = () => {
  const isAuthenticated = true;
  const navigate = useNavigate();
  const [path, setPath] = useState("/");

  const { cartQuantity, cartTotal } = useSelector((state) => state.cart);

  useEffect(() => {
    setPath(window.location.pathname);
  }, [window]);

  const navControl = (path) => {
    setPath(path);
    navigate(path);
    console.log(path);
  };

  return (
    <>
      <button
        onClick={() => {
          navControl("/");
        }}
        className={`${
          path === "/" ? "text-orange-400" : "md:text-white"
        }  mx-1   flex flex-col justify-center items-center 
        }`}
      >
        <BiHome />
        <p className="text-sm ">Home</p>
      </button>

      <button
        onClick={() => {
          navControl("/products");
        }}
        className={`${
          path === "/products" ? "text-orange-400" : "md:text-white"
        }  mx-1  flex flex-col justify-center items-center `}
      >
        <MdLocalOffer /> <p className="text-sm ">All Products</p>
      </button>

      <button
        onClick={() => {
          navControl("/profile/liked");
        }}
        className={`${
          path === "/profile/liked" ? "text-orange-400" : "md:text-white"
        }  mx-1  flex flex-col justify-center items-center`}
      >
        <BiHeart /> <p className="text-sm ">Liked</p>
      </button>

      <button
        onClick={() => navControl(`${isAuthenticated ? "/profile" : "/login"}`)}
        className={`${
          path === "/profile" ? "text-orange-400" : "md:text-white"
        }  ${
          path === "/login" ? "text-orange-400" : "md:text-white"
        }mx-1 flex flex-col justify-center items-center`}
      >
        {isAuthenticated ? <MdAccountBox /> : <BiLogInCircle />}{" "}
        <p className="text-sm ">{isAuthenticated ? "Account" : "Login"}</p>
      </button>

      <button
        onClick={() => {
          navControl("/cart");
        }}
        className={`${
          path === "/cart" ? "text-white md:text-orange-400" : "text-white"
        } flex items-center pl-2 pr-1 py-1   rounded-l-3xl -translate-y-4 bg-gradient-to-r from-[#FFB800] to-[#FF7A00] md:bg-none md:translate-y-0`}
      >
        <BiCart className={`md:text-2xl`} />
        <div className="ml-1 px-[2px]">
          <h1 className="text-sm">৳{cartTotal}</h1>
          <p className="text-sm ">{cartQuantity} items</p>
        </div>
      </button>
    </>
  );
};

export default DownBar;
